import * as React from 'react';
import classNames from 'classnames';
import './Loaders.scss';

export interface IDotLoaderProps {
  className?: any;
  inline?: boolean;
}

export const DotLoader = ({ className, inline }: IDotLoaderProps) => (
  <div className={classNames(
    'dot-loader',
    inline && 'is-inline',
    className
  )}>
    <div />
    <div className="mx2" />
    <div />
  </div>
);

export interface ILoaderSlateProps {
  children?: any;
  className?: any;
}

export const LoaderSlate = ({ children, className }: ILoaderSlateProps) => (
  <div
    style={{ minHeight: 400 }}
    className={classNames(
      'flex f4 fw6 flex-column items-center justify-center',
      className
    )}
  >
    <DotLoader className="mb4" />
    {children}
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Loaders/index.tsx